/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValueWithNote
 */
export interface ValueWithNote {
    /**
     * 
     */
    value?: string;
    /**
     * 
     */
    note?: string;
}

/**
 * Check if a given object implements the ValueWithNote interface.
 */
export function instanceOfValueWithNote(value: object): value is ValueWithNote {
    return true;
}

export function ValueWithNoteFromJSON(json: any): ValueWithNote {
    return ValueWithNoteFromJSONTyped(json, false);
}

export function ValueWithNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValueWithNote {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function ValueWithNoteToJSON(json: any): ValueWithNote {
    return ValueWithNoteToJSONTyped(json, false);
}

export function ValueWithNoteToJSONTyped(value?: ValueWithNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'note': value['note'],
    };
}

